var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[244],"data-type":_vm.dataType,"field-code":"facility","graph-id":65,"title":"(시설물) 중대재해 발생 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }